import { T, useI18n } from '../lib/i18n'
import { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Logo } from '../components/Logo'
import { supabase } from '../lib/supabase'
import { formatTeamInvitationCode, invitationPath, pendingInvitation, pendingTeamInvitation } from '../lib/invitations'

export function AuthCallbackPage() {
  const navigate = useNavigate()
  const { t } = useI18n()
  const started = useRef(false)
  const [errorMessage, setErrorMessage] = useState<string | null>(null)

  useEffect(() => {
    if (started.current) return
    started.current = true
    async function finish() {
      try {
        const params = new URLSearchParams(window.location.search)
        const providerError = params.get('error_description') ?? params.get('error')
        if (providerError) throw new Error(providerError)
        const code = params.get('code')
        if (!code) throw new Error(t('The sign-in provider did not return a secure authorization code.'))
        const { error } = await supabase.auth.exchangeCodeForSession(code)
        if (error) throw error
        const teamInvitation = pendingTeamInvitation()
        const invitation = pendingInvitation()
        const storedReturnPath = window.sessionStorage.getItem('tidyping.auth-return')
        window.sessionStorage.removeItem('tidyping.auth-return')
        const destination = teamInvitation
          ? `/team/join/${encodeURIComponent(formatTeamInvitationCode(teamInvitation))}`
          : invitation
            ? invitationPath(invitation)
            : storedReturnPath?.startsWith('/') ? storedReturnPath : '/'
        navigate(destination, { replace: true })
      } catch (error) {
        setErrorMessage(error instanceof Error ? t(error.message) : t('Sign in could not be completed.'))
      }
    }
    void finish()
  }, [navigate, t])

  return (
    <div className="callback-page">
      <Logo />
      {errorMessage ? (
        <>
          <strong><T>{"Sign in was not completed"}</T></strong>
          <p>{errorMessage}</p>
          <button className="button button--primary" onClick={() => navigate('/signin', { replace: true })}><T>{"Back to sign in"}</T></button>
        </>
      ) : (
        <>
          <div className="callback-loader"><span /><span /><span /></div>
          <strong><T>{"Securing your workspace…"}</T></strong>
        </>
      )}
    </div>
  )
}
